<h3 translate [translateParams]="{ name: item.product.name }">checkout-booking-cart-item.dialog-header</h3>

<ng-container *ngIf="bookableClasses$ | async as bookableClasses; else loading">
  <ng-container *ngIf="bookableClasses.length; else noClasses">
    <vnm-checkout-bookable-class
      *ngFor="let ilClass of bookableClasses"
      [ilClass]="ilClass"
      (selectedClass)="onSelectClass(ilClass)"
    ></vnm-checkout-bookable-class>
  </ng-container>

  <ng-template #noClasses>
    <div class="no-classes" translate>checkout-bookable-class-list.no-classes</div>
  </ng-template>
</ng-container>

<ng-template #loading>
  <div class="loading" translate>
    <p-progressSpinner></p-progressSpinner>
  </div>
</ng-template>

<p-footer class="sticky-footer">
  <button
    type="button"
    pButton
    pRipple
    [label]="'checkout-bookable-class-list.close' | translate"
    (click)="onCloseButtonClick()"
    icon="fa fa-arrow-left"
  ></button>
</p-footer>
